'use client';
import SVGelem from '@components/SVGelem/SVGelem';
import useScroll from '@lib/tools/hooks/useScroll';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { animated, useSpring } from '@react-spring/web';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { useLayoutEffect, useState } from 'react';
import style from './ButtonToTop.module.scss';

function ButtonToTop() {
  const { isMobile, viewport } = useViewport();
  const { scrollY } = useScroll();
  const [toggle, setToggle] = useState(false);
  const [toggleBottom, setToggleBottom] = useState(false);

  const updateToggleStates = (scrollY, innerHeight, scrollHeight, innerWidth, isMobile) => {
    const toggleThreshold = isMobile ? innerHeight / 3 : innerHeight / 2;
    const bottomThreshold = scrollHeight - innerHeight - (200 / (isMobile ? 375 : 1600)) * innerWidth;

    setToggle(scrollY > toggleThreshold);
    setToggleBottom(scrollY >= bottomThreshold);
  };

  const handleScrollWithScrollSmoother = () => {
    const smoother = ScrollSmoother.get();
    if (smoother) {
      updateToggleStates(scrollY, window.innerHeight, document.body.scrollHeight, window.innerWidth, false);
    }
  };

  useLayoutEffect(() => {
    const useScrollSmoother = !isMobile && scrollY === 0;

    if (useScrollSmoother) {
      handleScrollWithScrollSmoother();
    } else {
      updateToggleStates(scrollY, window.innerHeight, document.body.scrollHeight, window.innerWidth, isMobile);
    }
  }, [scrollY, viewport, isMobile]);

  const scrollToTop = () => {
    const smoother = ScrollSmoother.get();
    if (smoother) {
      smoother.scrollTo(0, { duration: 1 });
    }
  };

  const scrollToTopMobile = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleUp = () => {
    if (isMobile || (!isMobile && scrollY !== 0)) {
      scrollToTopMobile();
    } else scrollToTop();
  };

  const animatedStyle = useSpring({
    config: {
      duration: 800,
      mass: 1,
      tension: 280,
      friction: 120,
    },
    opacity: toggle ? 1 : 0,
    delay: 0,
    top: toggleBottom ? '35vh' : '80vh',
  });

  const animatedStyleMob = useSpring({
    config: {
      duration: 800,
      mass: 1,
      tension: 280,
      friction: 120,
    },

    opacity: toggle ? 1 : 0,
    delay: 0,
    top: toggleBottom ? '25vh' : '70vh',
  });

  return (
    <animated.button
      data-scroll
      data-scroll-sticky
      data-scroll-target='#fixed-target'
      style={!isMobile ? animatedStyle : animatedStyleMob}
      className={style.button}
      onClick={() => handleUp()}
    >
      <SVGelem href='#arrow-small-white' className={style.buttonIcon} />
    </animated.button>
  );
}

export default ButtonToTop;
